import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var GesturePhase = /** @class */ (function (_super) {
    __extends(GesturePhase, _super);
    function GesturePhase() {
        return _super.call(this) || this;
    }
    GesturePhase.classInitializer = null;
    GesturePhase.classSymbols = null;
    GesturePhase.instanceSymbols = null;
    // JS -> AS Bindings
    GesturePhase.BEGIN = 'begin';
    GesturePhase.UPDATE = 'update';
    GesturePhase.END = 'end';
    GesturePhase.ALL = 'all';
    return GesturePhase;
}(ASObject));
export { GesturePhase };
